import gql from 'graphql-tag';

export const MODIFY_SEGMENT_PROPERTIES = gql`
  mutation setCouponSegmentProperties(
    $params: SetCouponSegmentPropertiesInput!
  ) {
    setCouponSegmentProperties(params: $params) {
      updatedSegmentProperties {
        segmentUuid
        segmentStartDate
        segmentEndDate
        updatedBy
        cashbackDailyLimit
      }
    }
  }
`;

export default MODIFY_SEGMENT_PROPERTIES;
